import { useTable } from "react-table";
import { useMemo, useState } from "react";
import primaryComponents from "../../primaryComponents";
import secondaryComponents from "..";
import { DeleteIcon } from "../../../assets/svgIcons";
import { useGetChartAccountDetails } from "../../../hooks/api/queries";

const useBankAccountsListLogic = ({ banks, refetch }) => {
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedDeleteAccount, setSelectedDeleteAccount] = useState(null);

  const { isLoading: isFetchingBankInfo, data: bankInfo } =
    useGetChartAccountDetails(selectedBank || selectedDeleteAccount);
  const columns = useMemo(
    () => [
      {
        Header: "Account Code",
        accessor: "account_code",
        Cell: ({ cell: { value } }) => (value ? value : "N/A"),
      },
      {
        Header: "Bank Name",
        accessor: "bank_name",
        Cell: ({ cell: { value } }) => (value ? value : "N/A"),
      },
      {
        Header: "Account Number",
        accessor: "account_number",
        Cell: ({ cell: { value } }) => (value ? value : "N/A"),
      },
      {
        Header: "Account Name",
        accessor: "account_name",
        Cell: ({ cell: { value } }) => (value ? value : "N/A"),
      },
      {
        Header: "Bank Account Type",
        accessor: "bank_account_type_label",
        Cell: ({ cell: { value } }) => (value ? value : "N/A"),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ cell: { row } }) => (
          <div className="d-flex" style={{ gap: "5px" }}>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Accounting"}
              permissionChildKey="can_update_ledger_account"
            >
              <primaryComponents.Button
                classNames={"btn btn--primary smallBtn"}
                isDisabled={!row?.original}
                onClick={() => {
                  if (row?.original?.id) {
                    setSelectedBank(row?.original?.id);
                  }
                }}
              >
                Update
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Accounting"}
              permissionChildKey="can_delete_ledger_account"
            >
              <primaryComponents.Button
                classNames={"btn btn--outline-red smallBtn"}
                onClick={() => {
                  if (row?.original?.id) {
                    setSelectedDeleteAccount(row?.original?.id);
                  }
                }}
              >
                <DeleteIcon type="menu" />
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>
        ),
      },
    ],
    [selectedBank, refetch],
  );

  const instance = useTable({ columns, data: banks });
  return {
    instance,
    selectedBank,
    banks,
    refetch,
    selectedDeleteAccount,
    setSelectedDeleteAccount,
    setSelectedBank,
    bankInfo,
    isFetchingBankInfo,
  };
};

export default useBankAccountsListLogic;
